import Immutable from 'immutable';
import { createStore, getActionIds } from '../helpers/redux';

import { ProjectActions } from '../actions/project';
import { TagActions } from '../actions/tag';
import { ViewActions } from '../actions/view';
import { ElementActions } from '../actions/element';
import { ElementTypeActions } from '../actions/elementType';

const projectActions = getActionIds(ProjectActions);
const viewActions = getActionIds(ViewActions);
const tagActions = getActionIds(TagActions);
const elementActions = getActionIds(ElementActions);
const elementTypeActions = getActionIds(ElementTypeActions);

const initialState = Immutable.fromJS({
  elements: {},
  elementTypes: {},
  objectTags: {},
});

export const objectTags = createStore(initialState, {
  [projectActions.resetReducers]: (state, action) => {
    return initialState;
  },

  // [tagActions.getElementTags.success]: (state, action) => {
  //   const id = action.result.id;
  //   return state.mergeDeep({
  //     elements: {
  //       [id]: action.result.data.result,
  //     },
  //   });
  // },

  [elementActions.clientDeleteElements]: (state, action) => {
    let elements = state.get('elements');

    action.elementIds.forEach(elementId => {
      elements = elements.delete(elementId);
    });

    return state.setIn(['elements'], elements);
  },

  [projectActions.getRootElement.success]: (state, action) => {
    if (!action.result.entities.objectTags) return state;

    return state.mergeDeep({
      objectTags: action.result.entities.objectTags,
    });
  },

  [tagActions.tagObject.success]: (state, action) => {
    if (!action.result || !action.result.entities.objectTags) return state;

    return state.mergeDeep({
      objectTags: action.result.entities.objectTags,
    });
  },

  [viewActions.tagDefaultCycles.success]: (state, action) => {
    if (
      !action.result ||
      !action.result.elements ||
      !action.result.elements.entities.objectTags
    )
      return state;

    return state.mergeDeep({
      objectTags: action.result.elements.entities.objectTags,
    });
  },

  [elementTypeActions.deleteElementType.success]: (state, action) => {
    let elementTypes = state.get('elementTypes');
    elementTypes = elementTypes.delete(action.result.elementTypeId);
    return state.setIn(['elementTypes'], elementTypes);
  },

  // [tagActions.tagObject.success]: (state, action) => {
  //   if(!action.result.entities.tags) return state;

  //   const taggableType = action.args[0].taggableType;
  //   const taggableId = action.args[0].taggableId;
  //   let taggableReducer;

  //   switch(taggableType){
  //     case "element":
  //       taggableReducer = 'elements';
  //       break;
  //     case "element-type":
  //       taggableReducer = 'elementTypes';
  //       break;
  //     case "relationship-type":
  //       taggableReducer = 'relationshipTypes';
  //       break;
  //     case "default":
  //       taggableReducer = 'projects';
  //       break;
  //     case "project":
  //       taggableReducer = 'projects';
  //       break;
  //     case "views":
  //       taggableReducer = 'views';
  //       break;
  //   }

  //   let objectTagsList = [];
  //   Object.keys(action.result.entities.tags).forEach((tagId) => {
  //     objectTagsList.push(tagId);
  //   });

  //   return state.setIn([taggableReducer, taggableId], List(objectTagsList));
  // },

  // [tagActions.untagElement.begin]: (state, action) => {
  //   const [elementId, tagId] = action.args;
  //   // const elementId = action.result.elementId;
  //   // const tagId = action.result.tagId;
  //   const elementTagIds = state.getIn(['elements', elementId]);
  //   const tagIdIndex = elementTagIds.indexOf(tagId);
  //
  //   return state.setIn(
  //     ['elements', elementId],
  //     elementTagIds.delete(tagIdIndex),
  //   );
  // },
  //
  // [tagActions.untagElement.success]: (state, action) => {
  //   // const elementId = action.result.elementId;
  //   // const tagId = action.result.tagId;
  //   // const elementTagIds = state.getIn(['elements', elementId]);
  //   // const tagIdIndex = elementTagIds.indexOf(tagId);
  //
  //   // return state.setIn(['elements', elementId], elementTagIds.delete(tagIdIndex));
  //   return state;
  // },
  //
  // [tagActions.untagElement.failure]: (state, action) => {
  //   const [elementId, tagId] = action.args;
  //   const elementTagIds = state.getIn(['elements', elementId]);
  //
  //   return state.setIn(['elements', elementId], elementTagIds.push(tagId));
  // },
});

export const objectTagsSelector = (state, props) => {
  return state.objectTags.get('objectTags');
};



// WEBPACK FOOTER //
// ./src/reducers/objectTags.js